<template>
    <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <template v-if="!overlay">
            <center v-if="latest_timer!=null">
                <v-chip class="ma-2" large  outlined color="#0f2027">
                    Next Exam starts in {{show_time}}
                    <br />
                    (dd:hh:mm:ss)
                </v-chip>
            </center>
            <template>
                <v-simple-table  dense class="mytable elevation-1">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Exam Instructions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Make sure you are on stable network (Good internet speed)</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Once exam starts, please DO NOT leave the browser or switch the tabs</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Make sure your broswer is updated to latest version</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <br />
            <!-- </template> -->
            <v-simple-table  dense class="mytable elevation-1">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>Course</th>
                            <th>Test</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Extra Time Given</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item) in test_curr" :key="item.test.id">
                            <td>{{item.course_name}}</td>
                            <td>{{ item.test.title }}</td>
                            <td>{{ item.start_date }}</td>
                            <td>{{ item.end_date }}</td>
                            <td>{{item.extra_time}}</td>
                            <td v-if="item.test.vclinkapplicable">
                                <template v-if="item.show_result=='NO'">
                                    <span v-if="link_join_done==false">
                                        <v-btn color="warning" outlined small rounded :loading="start_test_loader" @click=" open_win(item.test,item.coff_id)">Start Test</v-btn>
                                    </span>
                                    <span v-else>
                                        <span v-if="item.test.id==r_id">
                                            <v-btn color="warning" outlined small rounded :loading="start_test_loader" @click="startTest(item.test,item.coff_id)">Start Test</v-btn>
                                            <!-- <v-btn color="success" :loading="start_test_loader" @click="startTest(item.test)">Start Test</v-btn> -->
                                        </span>
                                        <span v-else>
                                            <v-btn color="warning" outlined small rounded :loading="start_test_loader" @click=" open_win(item.testitem.coff_id)">Start Test</v-btn>
                                        </span>
                                    </span>
                                </template>
                                <template v-if="item.show_result=='YES'">
                                 <!--   <v-btn color="warning" :loading="start_test_loader" @click="showTest(item.result)">Submitted</v-btn> -->
                                 <v-btn color="warning" :loading="start_test_loader">Submitted</v-btn>
                                </template>
                            </td>
                            <td v-else>
                                <template v-if="item.show_result=='NO'">
                                    <v-btn color="warning" outlined small rounded :loading="start_test_loader" @click="startTest(item.test,item.coff_id)">Start Test</v-btn>
                                </template>
                                <template v-if="item.show_result=='YES'">
                                    <!-- <v-btn color="warning" outlined small rounded :loading="start_test_loader" @click="showTest(item.result)">Submitted</v-btn> -->
                                    <v-btn color="warning" outlined small rounded :loading="start_test_loader">Submitted</v-btn> 
                                </template>
                            </td>
                        </tr>
                        <tr v-for="(item) in test_upcoming" :key="item.test.id" class="text-secondary">
                            <td>{{item.course_name}}</td>
                            <td>{{ item.test.title }}</td>
                            <td>{{ item.start_date }}</td>
                            <td>{{ item.end_date }}</td>
                             <td>{{item.extra_time}}</td>
                            <td>Not started</td>
                        </tr>
                        <tr v-for="(item) in test_result" :key="item.test.id" class="text-color-DC3545">
                            <td>{{item.course_name}}</td>
                            <td>{{ item.test.title }}</td>
                            <td>{{ item.start_date }}</td>
                            <td>{{ item.end_date }}</td>
                             <td>{{item.extra_time}}</td>
                            <td v-if="item.lqfs == null">Not Attended</td>
                            <td v-else>
                            <v-btn color="warning" outlined small rounded :loading="start_test_loader">Submitted</v-btn> 
                                <!-- <v-btn small class="button" @click="getResult(item.lqfs, item.result)">Result</v-btn> -->
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </template>
        <v-overlay :value="overlay" absolute>
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row justify="center">
            <v-dialog v-model="dialog" max-width="400">
                <v-card>
                    <v-card-title class="card-title">Test is Under Supervision</v-card-title>
                    <v-card-text class="text-tilte">
                        This Test is under supervision of instructor. Please join video conferencing link and come back to VOLP Otherwise your Test marks performance will be considered null & void. Please do not close video conferencing
                        link during exam.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <input type="hidden" v-model="link_join" />
                        <input type="hidden" v-model="r_id" />
                        <v-btn color="green darken-1" text @click="dialog = false">Close</v-btn>
                        <v-btn color="primary" @click="openWindowMeet(750,500)">Join</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-dialog v-if="summary!=null" v-model="dialog1" width="600px">
            <v-card>
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Test Result
                    </strong>
                </v-toolbar-title>
                 </v-toolbar>
                <v-card class="box">
                    <center>
                        <v-progress-circular class="mt-4" :rotate="360" :size="150" :width="15" :value="graphBar" color="#0f2027">{{graphBar}} %</v-progress-circular>
                        <h5 class="mt-4 font-weight-bold">Obtained Marks: {{summary.actualmarks }}</h5>
                        <h5 class="mt-4 font-weight-bold">Total Marks: {{ summary.total }}</h5>
                        <h5 class="mt-4 font-weight-bold">Correct Answer: {{ summary.totalcorrect }}</h5>
                        <h5 class="mt-4 font-weight-bold">Total Questions: {{ summary.totalquestion }}</h5>
                    </center>
                </v-card>
                 <v-row justify="center" class="mt-4">
                            <v-btn class="button" @click="dialog1 = false">Close</v-btn>
                        </v-row>
            </v-card>
        </v-dialog>
        </template>
    </div>
</template>

<script>
    import axios from "axios";
   import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        name: "Timer",
        //   components: { Countdown },
        data: () => ({
            dialog: false,
            overlay: true,
            colid: null,
            test_curr: null,
            test_upcoming: null,
            test_result: null,
            refresh_timer: 100000,
            latest_timer: null,
            upcoming_event: null,
            timer: null,
            course_name: null,
            start_test_loader: false,
            link_join: "",
            link_join_done: false,
            r_id: null,
            summary: null,
            dialog1: false,
            //new code
            totalsec: 0,
            show_time: "",
            tim: null,
            snackbar_msg:null,
            color:null,
            snackbar:false
        }),
        computed: {
            end_time() {
                return this.latest_timer.end_time;
            },
        },
        mounted() {
            this.init_call();
        },
        beforeDestroy() {
            console.log("destroy");
            clearInterval(this.tim);
         },
        methods: {
            sformat(s) {
                var fm = [
                    Math.floor(Math.floor(Math.floor(s / 60) / 60) / 24) % 24, //DAYS
                    Math.floor(Math.floor(s / 60) / 60) % 60, //HOURS
                    Math.floor(s / 60) % 60, //MINUTES
                    s % 60, //SECONDS
                ];
                return $.map(fm, function (v, i) {
                    return (v < 10 ? "0" : "") + v;
                }).join(":");
            },
            showtime() {
                //console.log("showtime");
                // 1 seconde eraf
                this.totalsec--;
                this.show_time = this.sformat(this.totalsec);
                if (this.totalsec == 0) {
                    clearInterval(this.tim);
                    this.init_call();
                }
            },
            log() {
                //console.log("Hello world");
                //alert("Timeup")
                this.latest_timer = null;
                this.init_call();
                //this.gettimer()
            },
            startCallBack: function (x) {
                console.log(x);
            },
            endCallBack: function (x) {
                console.log("auto end");
                this.latest_timer = null;
                this.init_call();
                //alert(x)
            },
            open_win(data) {
                //alert("Data :"+data.id)
                this.dialog = true;
                this.link_join = data.vclink;
                this.r_id = data.id;
                this.link_join_done = false;
                //alert("Data  Linnk:"+this.link_join)
            },
            openWindowMeet() {
                var w = 750;
                var h = 500;
                var leftOffset = screen.width / 2 - w / 2;
                var topOffset = screen.height / 2 - h / 2;
                this.dialog = false;
                this.link_join_done = true;
                return window.open(this.link_join, this.target, "left=" + leftOffset + ",top=" + topOffset + ",width=" + w + ",height=" + h + ",resizable,scrollbars=yes");
            },
                showSnackbar(clr, msg) {
                    this.snackbar = true;
                    this.color = clr;
                    this.snackbar_msg = msg;
                },
            init_call() {
                this.upcoming_event = null;
                this.overlay = true;
                axios
                    .post("/LearnerQuiz/testList")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.test_curr = res.data.test_curr;
                            this.test_upcoming = res.data.test_upcoming;
                            this.test_result = res.data.test_result;
                            this.refresh_timer = res.data.refresh_timer;
                           // this.course_name = res.data.course_name;
                           this.colid = res.data.learner
                            this.latest_timer = res.data.latest_timer;
                            if (this.refresh_timer != null) {
                                this.totalsec = this.refresh_timer;
                                console.log("b4 start:" + this.totalsec);
                                if (this.totalsec > 0) {
                                    this.tim = setInterval(() => {
                                        this.showtime();
                                    }, 1000);
                                }
                            }
                        }
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong !!!");
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something went wrong !!!");
                        this.$router.push({
                            name: "learner-course-data",
                            params: { id: this.course_name },
                        });
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },

            getResult(lqfs, result) {
                console.log(lqfs);
                this.$session.set("lqfs", JSON.stringify(lqfs));
                this.$session.set("result", JSON.stringify(result));
                this.$router.push({
                    name: "learner-course-test-result",
                    params: { id: this.course_name },
                });
            },
            showTest(result) {
                console.log(result);
                this.dialog1 = true;
                this.summary = result;
            },
            startTest(test,coff_id) {
                console.log(test);
                const formData = {
                    colid: this.colid,
                    test: test.id,
                    coff_id:coff_id,
                };
                this.start_test_loader = true;
                axios
                    .post("/LearnerQuiz/initQuiz", formData)
                    .then((res) => {
                        if(res.data.flag == "NO"){
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return
                        }
                        if (res.data.flag == "YES") {
                            console.log("res.data.test_ques_list")
                            console.log(res.data.test_ques_list)
                            this.$session.set("test_ques_list", JSON.stringify(res.data.test_ques_list));
                            this.$session.set("lqfs", JSON.stringify(res.data.lqfs));
                            this.$session.set("path", JSON.stringify(res.data.aws_path));
                            this.$router.push({ name: "learner-start-exam" });
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong !!!");
                        }
                    })
                    .catch((error) => {
                            console.log('error', error)
                            this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        this.start_test_loader = false;
                    });
            },
        },
        computed: {
            graphBar() {
                var number = (this.summary.actualmarks / this.summary.total) * 100;
                return number.toFixed(2);
            },
         },
     };
</script>

<style scoped>
 .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(
            to bottom,
            var(--v-brand-base) 0%,
            var(--v-brand-base) 80%,
            var(--v-brandLight-base) 100%
        ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: var(--v-onBrand-base) !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
</style>
